module.exports = __webpack_public_path__ + "static/workPlace-62dad7f1e15b80494f0ce170a908833e.png";